<template>
  <b-form>
    <b-form-row>
      <b-col cols="6">
        <h3>Geselecteerde categorieën</h3>
        <div class="overflow-auto border p-1 rounded" style="height: 230px; width: 85%">
          <draggable class="dragArea list-group"
                     :list="selectedList"
                     @clone="onClone($event)"
                     group="people">
            <div class="list-group-item"
                 v-for="element in selectedList"
                 :key="element">
              {{ element }}
            </div>
          </draggable>
        </div>
      </b-col>

      <b-col cols="5">
        <div style="display:inline">
          <h3 style="float:left">Beschikbare categorieën</h3>
          <b-button v-b-tooltip.hover title="Sleep de categorieën om ze toe te voegen." style="border-radius:20px; float: right; font-size:smaller">
            ?
          </b-button>
        </div>
        <div class="w-100 overflow-auto border p-1 rounded" style="height: 230px;">
          <draggable class="dragArea list-group"
                     :list="unselectedList"
                     group="people"
                     @clone="onClone($event)">
            <div class="list-group-item"
                 v-for="element in unselectedList"
                 :key="element">
              {{ element }}
            </div>
          </draggable>
        </div>
      </b-col>
    </b-form-row>
  </b-form>
</template>
<script>
  import draggable from 'vuedraggable'
  export default {
    name: 'ArticleCategories',
    data() {
      return {
        selectedList: this.selectedCategoryList,
        unselectedList: this.unselectedCategoryList
      }
    },
    computed: {
      dragOptions() {
        return {
          group: {
            name: 'g1'
          },
          scrollSensitivity: 200,
          forceFallback: true
        };
      }
    }, 
    props: {
      selectedCategoryList: [],
      unselectedCategoryList: [],
    },
    components: {
      draggable,
    },
    methods: {
      onClone(event) {
        const itemCanvas = event.item.getElementsByTagName("canvas")[0];
        const cloneCanvas = event.clone.getElementsByTagName("canvas")[0];

        const cloneCanvasContext = cloneCanvas.getContext("2d");
        cloneCanvasContext.drawImage(itemCanvas, 0, 0);
      }
    }
  }
</script>
